import { Component, Input, Output, EventEmitter, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PdfViewerComponent } from '@app/common-codes/components/nested-components/pdf-viewer/pdf-viewer.component';
import { SignaturePadComponent } from '@app/common-codes/components/nested-components/signature-pad/signature-pad.component';
import { TranslatePipe } from "@app/common-codes/components/directives/TranslatePipe";

export interface PolicyViewerAcceptEvent {
    accepted: boolean;
}

@Component({
    selector: 'app-policy-viewer',
    standalone: true,
    imports: [CommonModule, FormsModule, PdfViewerComponent, SignaturePadComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './policy-viewer.component.html'
})
export class PolicyViewerComponent {

    @Input() url?: string;
    @Input() showSignature: boolean = true;
    @Input() signatureHeight: number = 200;

    @Output() accepted = new EventEmitter<PolicyViewerAcceptEvent>();
    @Output() signatureChange = new EventEmitter<File | null>();

    pdfRead = signal(false);
    policyAccepted = false;

    onPdfRead(event: boolean): void {
        this.pdfRead.set(event);
    }

    onPolicyAcceptedChange(event: any): void {
        this.policyAccepted = event.target.checked;
        this.accepted.emit({ accepted: this.policyAccepted });
    }

    onSignatureChange(file: File | null): void {
        this.signatureChange.emit(file);
    }
}